function mouseParallax(id, left, top, mouseX, mouseY, speed) {
  var obj = document.getElementById(id);
  var parentObj = obj,
    containerWidth = parseInt(parentObj.offsetWidth),
    containerHeight = parseInt(parentObj.offsetHeight);
  obj.style.left =
    left -
    ((mouseX - (parseInt(obj.offsetWidth) / 2 + left)) / containerWidth) *
      speed +
    "px";
  obj.style.top =
    top -
    ((mouseY - (parseInt(obj.offsetHeight) / 2 + top)) / containerHeight) *
      speed +
    "px";
}

function resetPosition(id) {
  var obj = document.getElementById(id);
  obj.style.top = "";
  obj.style.left = "";
}

$(document).ready(function() {
  var countDownDate = new Date("Jan 19, 2020 04:00:00").getTime();
  setInterval(function() {
    var distance = countDownDate - new Date().getTime();

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var elm = $(".block-count-down ul li .content");
    var arrTime = [days, hours, minutes, seconds];
    arrTime.forEach((item, index) => {
      if (item < 10) {
        elm[index].innerText = "0" + item;
      } else {
        elm[index].innerText = item;
      }
    });
    // if (distance < 0) {
    //   clearInterval(x);
    //   alert("EXPIRED");
    // }
  }, 1000);

  // Event mouse move
  var c2left, c2top, c3left, c3top, c4left, c4top;
  var screenwidth = window.screen.width;
  $(window).on("load", function() {
    c2left = document.getElementById("img1").offsetLeft;
    c2top = document.getElementById("img1").offsetTop;
    c3left = document.getElementById("img2").offsetLeft;
    c3top = document.getElementById("img2").offsetTop;
    c4left = document.getElementById("img3").offsetLeft;
    c4top = document.getElementById("img3").offsetTop;
  });

  $(window).on("resize", function() {
    resetPosition("img1");
    resetPosition("img2");
    resetPosition("img3");
    c2left = document.getElementById("img1").offsetLeft;
    c2top = document.getElementById("img1").offsetTop;
    c3left = document.getElementById("img2").offsetLeft;
    c3top = document.getElementById("img2").offsetTop;
    c4left = document.getElementById("img3").offsetLeft;
    c4top = document.getElementById("img3").offsetTop;
  });
  var parallaxBox = document.getElementById("body");
  parallaxBox.onmousemove = function(event) {
    if (screenwidth >= 1024) {
      if (document.readyState === "complete") {
        event = event || window.event;
        var x = event.clientX - parallaxBox.offsetLeft,
          y = event.clientY - parallaxBox.offsetTop;

        mouseParallax("img1", c2left, c2top, x, y, 5);
        mouseParallax("img2", c3left, c3top, x, y, 10);
        mouseParallax("img3", c4left, c4top, x, y, 20);
      }
    }
  };
});
